import { render, staticRenderFns } from "./PurchasedItemBase.vue?vue&type=template&id=f56aa800&scoped=true&"
import script from "./PurchasedItemBase.vue?vue&type=script&lang=ts&"
export * from "./PurchasedItemBase.vue?vue&type=script&lang=ts&"
import style0 from "./PurchasedItemBase.vue?vue&type=style&index=0&id=f56aa800&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56aa800",
  null
  
)

export default component.exports